<div class="cw-flex-column">
    <phscw-global-help-nav class="nav"></phscw-global-help-nav>
    <phscw-global-help-lists class="lists"></phscw-global-help-lists>
</div>
